// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact_us_header {
  width: 100%;
  background-color: var(--background-theme-color);
  display: flex;
  justify-content: center;
  padding: 20px 0 30px 0;
}
.white_font {
  color: #ffffff;
  font-weight: 700;
  font-family: kufam;
}
.contact_us_header_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 90%;
  gap: 20px;
}

.contact_us_section_wrapper {
  width: 60%;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 5%;
}

.feedback-input {
  height: 50px !important;
  background-color: transparent !important;
  border-color: #e79432;
  font-size: 15px;
  transition: border-color 0.3s ease;
  color: #000000 !important;
}
body.dark_mode .feedback-input{
  height: 50px !important;
  background-color: transparent !important;
  border-color: #e79432;
  font-size: 15px;
  transition: border-color 0.3s ease;
  color: #ffffff !important;
}
body.dark_mode .feedback-input::placeholder{
  color: rgb(146, 142, 142) !important;
}
body.dark_mode :where(.css-dev-only-do-not-override-zg0ahe).ant-input-number .ant-input-number-input {
  color: white;
}
body.dark_mode :where(.css-dev-only-do-not-override-zg0ahe).ant-input-number .ant-input-number-input::placeholder {
  color: rgb(146, 142, 142) !important;
}
body.dark_mode .divider_text{
  color: white;
}

.feedback-input:hover {
  border-color: #e79432;
  outline: none;
}

.feedback-input:focus {
  border-color: #e79432;
  outline: none;
}

.form_submit_button {
  background-color: var(--become-member-button) !important;
  color: #ffffff !important;
  border-radius: 6px;
  border: none;
  width: 160px;
}
.contact_us_divider_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
.contact_us_divider {
  border-color: #e79432 !important;
}
.contact_card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}
.contact_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.contact_us_form_container {
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 20px !important;
}
.contact_us_donation_wrapper {
  width: 34%;
}
.contact_us_description {
  color: #ffffff;
}
.contact_us_description_ta {
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/contact_us.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,wDAAwD;EACxD,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":[".contact_us_header {\n  width: 100%;\n  background-color: var(--background-theme-color);\n  display: flex;\n  justify-content: center;\n  padding: 20px 0 30px 0;\n}\n.white_font {\n  color: #ffffff;\n  font-weight: 700;\n  font-family: kufam;\n}\n.contact_us_header_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 90%;\n  gap: 20px;\n}\n\n.contact_us_section_wrapper {\n  width: 60%;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 5%;\n}\n\n.feedback-input {\n  height: 50px !important;\n  background-color: transparent !important;\n  border-color: #e79432;\n  font-size: 15px;\n  transition: border-color 0.3s ease;\n  color: #000000 !important;\n}\nbody.dark_mode .feedback-input{\n  height: 50px !important;\n  background-color: transparent !important;\n  border-color: #e79432;\n  font-size: 15px;\n  transition: border-color 0.3s ease;\n  color: #ffffff !important;\n}\nbody.dark_mode .feedback-input::placeholder{\n  color: rgb(146, 142, 142) !important;\n}\nbody.dark_mode :where(.css-dev-only-do-not-override-zg0ahe).ant-input-number .ant-input-number-input {\n  color: white;\n}\nbody.dark_mode :where(.css-dev-only-do-not-override-zg0ahe).ant-input-number .ant-input-number-input::placeholder {\n  color: rgb(146, 142, 142) !important;\n}\nbody.dark_mode .divider_text{\n  color: white;\n}\n\n.feedback-input:hover {\n  border-color: #e79432;\n  outline: none;\n}\n\n.feedback-input:focus {\n  border-color: #e79432;\n  outline: none;\n}\n\n.form_submit_button {\n  background-color: var(--become-member-button) !important;\n  color: #ffffff !important;\n  border-radius: 6px;\n  border: none;\n  width: 160px;\n}\n.contact_us_divider_wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.contact_us_divider {\n  border-color: #e79432 !important;\n}\n.contact_card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n}\n.contact_info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.contact_us_form_container {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px !important;\n}\n.contact_us_donation_wrapper {\n  width: 34%;\n}\n.contact_us_description {\n  color: #ffffff;\n}\n.contact_us_description_ta {\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
